import { render, staticRenderFns } from "./CompetitionCaseAdd.vue?vue&type=template&id=eaf90a28&scoped=true"
import script from "./CompetitionCaseAdd.vue?vue&type=script&lang=js"
export * from "./CompetitionCaseAdd.vue?vue&type=script&lang=js"
import style0 from "./CompetitionCaseAdd.vue?vue&type=style&index=0&id=eaf90a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf90a28",
  null
  
)

export default component.exports